/**
 * SF-181 Component 3: strips a leading `+X.X%`/`-X.X%` prefix (and any following whitespace) off
 * an `effectDescription` string, so it can be appended after a row's own separately-rendered
 * percentage without doubling it. Extracted to a sibling non-component file — a named export from
 * SciencesOverviewTab.tsx (a component file) trips react-refresh/only-export-components
 * (investmentPlanner.ts/navPillars.ts precedent).
 */
export function stripLeadingPercentage(text: string): string {
  return text.replace(/^[+-][\d.]+%\s*/, '');
}
